var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d2-ribbon",attrs:{"href":_vm.repository,"target":"_blank"}},[_c('img',{attrs:{"src":require("./assets/ribbon@2x.png"),"draggable":"false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }